"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SideDrawerToggle = function (_PureComponent) {
  _inherits(SideDrawerToggle, _PureComponent);

  function SideDrawerToggle() {
    _classCallCheck(this, SideDrawerToggle);

    return _possibleConstructorReturn(this, (SideDrawerToggle.__proto__ || Object.getPrototypeOf(SideDrawerToggle)).apply(this, arguments));
  }

  _createClass(SideDrawerToggle, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "button",
        { className: "SideDrawerToggle", onClick: this.props.onClick },
        _react2.default.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "18",
            height: "12",
            fill: "none",
            viewBox: "0 0 18 12"
          },
          _react2.default.createElement("path", {
            fill: "#363a40",
            d: "M1 12h16c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zM0 1c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1z"
          })
        )
      );
    }
  }]);

  return SideDrawerToggle;
}(_react.PureComponent);

exports.default = SideDrawerToggle;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/SideDrawer/SideDrawerToggle.js
// module id = 606
// module chunks = 0